





















import { createComponent, computed } from "@vue/composition-api";
import { getResourceModule } from "@/apps/apps";
import { getResourceModulePath, getModulePath } from "@/apps/getPath";
import { SearchResult } from "@megarax/client/src/resources/search/SearchResult";

interface Props {
  value: SearchResult;
}

export default createComponent<Props>({
  components: {},
  props: { value: { required: true } },
  setup(props, ctx) {
    const iconClass = computed(() => {
      const assets = getResourceModule(props.value.app, props.value.resource);
      return assets.iconClass;
    });

    const itemModule = computed(() =>
      getResourceModule(props.value.app, props.value.resource),
    );

    const itemPath = computed(() =>
      getModulePath(itemModule.value, props.value.id),
    );

    return { iconClass, itemPath, itemModule };
  },
});
